<script lang="ts">
  /**
   * `/o/:orgId/security/exposed-sensitive-documents`.
   *
   * The claim gate is here rather than in the container, matching `OrgPISIDetection.svelte` and
   * `OrgPermissionAssurance.svelte`: the route decides who may see the page, the container only
   * renders it. The claim is the existing `org:security_findings`; there is no new claim.
   *
   * The gate is discoverability plus a courtesy - the Firestore rules are the real boundary - so
   * a user without the claim gets the same `PageAccessDenied` the other two security pages give.
   */
  import PageAccessDenied from "../PageAccessDenied.svelte";
  import { PageLoadingSpinner } from "$lib/ui/loading-spinner";
  import SectionTitle from "$lib/components/shared/SectionTitle.svelte";
  import ExposedSensitiveDocumentsContainer from "$lib/components/security/exposedSensitiveDocuments/ExposedSensitiveDocumentsContainer.svelte";
  import { hasOrgClaim } from "$lib/utils/orgClaims";
  import { EXPOSED_SENSITIVE_DOCUMENTS_CLAIM } from "$lib/stores/orgExposedSensitiveDocuments";
  import { selectedOrgStore } from "$lib/stores/orgs";
  import { authStateStore } from "$lib/stores/user";

  const canView = $derived(
    hasOrgClaim($selectedOrgStore, $authStateStore.userInfo?.email, EXPOSED_SENSITIVE_DOCUMENTS_CLAIM),
  );
</script>

{#if $selectedOrgStore === undefined}
  <!-- The org document has not arrived yet; denying access before it does would be a lie. -->
  <PageLoadingSpinner timeout={10_000} message={"Loading..."} />
{:else if canView}
  <div class="grow px-6 lg:px-10 py-5 sm:py-8 lg:py-10 text-offblack">
    <SectionTitle>Sensitive Data Exposure</SectionTitle>
    <ExposedSensitiveDocumentsContainer />
  </div>
{:else}
  <PageAccessDenied />
{/if}
